module.exports = __webpack_public_path__ + "static/media/header-reimburse.0a8bac06.jpg";